module.exports = __webpack_public_path__ + "img/onboarding-discount.97eec3b7.png";